import * as React from "react"
import { Info, LucideIcon } from "lucide-react"
import { Tooltip, TooltipTrigger, TooltipContent } from "./tooltip"
import { cn } from "../../lib/utils"

export interface IconTooltipProps {
    content: string | React.ReactNode
    icon?: LucideIcon
    iconClassName?: string
    tooltipClassName?: string
    side?: 'top' | 'right' | 'bottom' | 'left'
}

export const IconTooltip = React.forwardRef<SVGSVGElement, IconTooltipProps>(
    ({ content, icon: Icon = Info, iconClassName, tooltipClassName, side = 'top', ...props }, ref) => {
        return (
            <Tooltip>
                <TooltipTrigger asChild>
                    <Icon
                        ref={ref}
                        className={cn("h-3 w-3 text-muted-foreground cursor-help", iconClassName)}
                        {...props}
                    />
                </TooltipTrigger>
                <TooltipContent className={tooltipClassName} side={side}>
                    {typeof content === 'string' ? <p>{content}</p> : content}
                </TooltipContent>
            </Tooltip>
        )
    }
)
IconTooltip.displayName = "IconTooltip"

